export const blockIconsFileFileDownload = (
	<span className='material-symbols-outlined'>file_download</span>
);
